import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";
import { isContext } from "vm";
import { KnowledgeCheckUIConfig } from "../../components/ui/KnowledgeCheckUI";

export default class Scenario5Part5 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {

		scenario5_4C_s20: 'CALM - Scenario 5 - 4C - Segment 20',
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part9.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MarcoApproaches();

	}

	private segment1Step1MarcoApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();

		context.segment1Step2Dialogue()
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C10-S1-030b',
			[{
				text: 'It seems you followed the checklist, so go ahead and discharge him.',
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1MarcoDeparts(), context.partIndx);
			}
		);
	}

	private segment2Step1MarcoDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.playVideoChapter(this.chapterIds.scenario5_4C_s20, () => {
			context.scenario.showKnowledgeCheck((config: KnowledgeCheckUIConfig) => {
				for (var indx = 0; indx < config.questions.length; indx++) {
					var q = config.questions[indx];
					var scenarioID = 0;
					var sectionId = 0;
					var allCorrectChoices = q.choices.filter(c => c.isCorrect);
					var allSelectedCorrectChoices = q.choices.filter(c => c.isCorrect && c.isSelected);
					var isCorrect = allCorrectChoices.length === allSelectedCorrectChoices.length;
					
					if(q.title.startsWith('An in-patient was')) {
						scenarioID = 0;
						sectionId = 3;
					} else if(q.title.startsWith('Patient was discharged')) {
						scenarioID = 2;
						sectionId = 2;
					} else if(q.title.startsWith('Interpreter services were ')) {
						scenarioID = 3;
						sectionId = 2;
					}
	
					var s = q.choices.map((cs, i) => {
						if(cs.isSelected) {
							return i;
						} else {
							return -1;
						}
					});
	
					this.scenario.evaluateAnswerForSummative({
						text: '',
						isCorrect: isCorrect
					}, {
						onOptionSelected: () => {},
						options: [
							{
								text: '',
								isCorrect: false
							},
							{
								text: '',
								isCorrect: true
							}
						],
						aarScenarioID: scenarioID,
						aarSectionID: sectionId,
						aarCollectionID: s.filter(sf => sf !== -1) 
					}, () => {}, 0)
				}
				this.segment2Step2ShowAAR()
			})	// END OF SUMMATIVE KNOWLEDGE CHECK, FOLLOWED BY AAR		
		})
	}

	private segment2Step2ShowAAR() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.showAar(1500, () => {
			context.onDone();
		});
	}
}